import LinkWithArrow from "@/components/links/LinkWithArrow/LinkWithArrow";
import Table from "@/components/Table/Table";
import {
  useGetTravelMode,
  useGetTravelModeRelations,
} from "@/pages/employee/travel_modes/useTravelMode";

export default function TravelRelations({ travelModeId }: { travelModeId: number }) {
  const {
    data: relations,
    isLoading: relationsLoading,
    isFetching: relationsFetching,
  } = useGetTravelModeRelations({
    travelModeId,
  });

  const { data } = useGetTravelMode({ travelModeId });

  return (
    <Table
      type="grey"
      hideRaster={true}
      loading={relationsLoading || relationsFetching}
      pagination={{ page: 1, pageSize: 5 }}
      data={relations}
      emptyState={{ noResultsMessage: "Not related to purchase or sales orders." }}
      columns={[
        {
          label: "Year",
          key: "year",
        },
        {
          label: "Commute",
          key: "commute",
          renderer: (record) => (
            <LinkWithArrow
              to={`/employees/commute?year=${record.year}&search_travel_mode=${encodeURI(
                data?.name || ""
              )}`}
            >
              {record.commute_count}
            </LinkWithArrow>
          ),
        },
        {
          label: "Business travel",
          key: "business_travel",
          renderer: (record) => (
            <LinkWithArrow
              to={`/employees/business_travel?year=${record.year}&search_travel_mode=${encodeURI(
                data?.name || ""
              )}`}
            >
              {record.business_travel_count}
            </LinkWithArrow>
          ),
        },
      ]}
      rowKey={"id"}
    />
  );
}
